// extracted by mini-css-extract-plugin
module.exports = {"preOrder":"PreOrder_preOrder__vKc_7","tooltips":"PreOrder_tooltips__zKXLP"};